module.exports = {"430204001":"田心街道","430204002":"响石岭街道","430204003":"清水塘街道","430204004":"铜塘湾街道","430204005":"井龙街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430204.json
// module id = 1816
// module chunks = 0